import React, { useEffect, useState } from "react";
import "./styles/App.css";
import { Route, Routes } from "react-router-dom";

import Login from "./pages/login";
import Dashboard from "./pages/dashboard";
import Logout from "./pages/logout";
import AddClient from "./pages/addClient";
import ClientDetail from "./pages/clientDetail";
import EditClient from "./pages/editClient";
import AddTransaction from "./pages/addTransaction";
import EditTransaction from "./pages/editTransaction";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  return (
    <Routes>
      <Route path="/" element={!isLoggedIn ? <Login /> : <Dashboard />} />
      <Route path="/login" element={!isLoggedIn ? <Login /> : <Dashboard />} />
      <Route
        path="/dashboard"
        element={isLoggedIn ? <Dashboard /> : <Login />}
      />
      <Route path="/logout" element={<Logout/>}></Route>
      <Route path="/addClient" element={<AddClient/>}></Route>
      <Route path="/clients/:id" element={<ClientDetail/>}></Route>
      <Route path="/clients/:id/edit" element={<EditClient/>}></Route>
      <Route path="/transactions/:id/edit" element={<EditTransaction/>}></Route>
      <Route path="/clients/:id/addTransaction" element={<AddTransaction/>}></Route>
    </Routes>
  );
}

export default App;
